// Padding-less cells: the h-full input/chip fills the cell (UltraTable pattern).
// h-px gives the cell a definite height so h-full children stretch to row height.
export const presetTableCellBase =
  'h-px border border-gray-300 p-0 text-sm align-middle';

export const presetTableHeaderCellBase =
  'h-px border border-gray-300 bg-gray-100 p-0 text-sm font-semibold align-middle';

/** Fixed layout so colgroup widths are respected instead of equal auto-sizing. */
export const presetTableBase =
  'w-full table-fixed border-collapse text-sm text-gray-900';
